<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <RoofPitchRadioFormPart @change="onChange" @result="onResult" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import RoofPitchRadioFormPart from 'chimera/dormer/components/form/parts/roofPitch/RoofPitchRadioFormPart'
import NextStep from '~/pages/offertes-aanvragen/locatie-dakkapel'

export default {
  name: 'RoofPitchFormStep',

  components: {
    RoofPitchRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
